module.exports = __webpack_public_path__ + "img/杭州市.41be2716.png";